export default "__VITE_ASSET__6dde0dd9__"